module.exports = __webpack_public_path__ + "img/gh-202-flwasher.prt.7179f24a.jpg";